module.exports = {"370282001":"环秀街道","370282002":"潮海街道","370282003":"通济街道","370282004":"北安街道","370282005":"龙山街道","370282006":"龙泉街道","370282007":"鳌山卫街道","370282008":"温泉街道","370282105":"蓝村镇","370282107":"灵山镇","370282115":"段泊岚镇","370282117":"移风店镇","370282119":"大信镇","370282121":"田横镇","370282122":"金口镇"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370282.json
// module id = 1267
// module chunks = 0